import { gql } from "@apollo/client";
import { hospital_query_str, province_query_str, zone_query_str } from "../components/Const/label";
import { client } from './DBserver';

export async function get_zone_data() {
    const query = gql(`
          query GetData {
            `+ zone_query_str + `
          }
        `);
    return client.query({ query: query });
}

export async function get_province_data(zone) {
    const query = gql(`
          query GetData($zone: String) {
            `+ province_query_str + `(zone: $zone)
            }
        `);
    const variables = {
        zone: zone || ''
    }
    return client.query({ query: query, variables: variables });
}

export async function get_hos_data(province) {
    const query = gql(`
          query GetData($province: String) {
            `+ hospital_query_str + `(province: $province)
            }
        `);
    const variables = {
        province: province || ''
    }
    return client.query({ query: query, variables: variables });
}


export async function query(queryname, variables) {
    if (variables !== undefined) {
        var variables_str = ''
        var variables_str2 = ''
        Object.keys(variables).forEach(o => {
            var type = typeof (variables[o])
            type = type === 'number' ? 'Int' : (type === 'string' ? 'String' : (type === 'boolean' ? 'Boolean' : ''))
            variables_str += '$' + o + ': ' + type + ', '
            variables_str2 += o + ': $' + o + ', '
        });
        variables_str = '(' + variables_str + ')'
        variables_str2 = '(' + variables_str2 + ')'
    }
    var query_str
    if (variables_str !== undefined)
        query_str = 'query GetData' + variables_str + ' {' + queryname + variables_str2 + ' {key, diseases{name, count}}}'
    else
        query_str = 'query GetData {' + queryname + ' {key, diseases{name, count}}}'

    console.log(query_str)
    console.log(variables)
    const query = gql(query_str)
    return (await client.query({ query: query, variables: variables })).data[queryname];
}